<template>
  <v-list-item :to="{ name: 'quote', params: { id: quote.id }}">
    <v-list-item-content>
      <v-list-item-title>{{ quote.quote | truncate }}</v-list-item-title>
      <v-list-item-subtitle v-if="quote.book || quote.page_number">
        <span v-if="quote.book" class="text--primary">{{ quote.book.title }}</span>
        <span v-if="quote.page_number"> p.&nbsp;{{ quote.page_number }}</span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <span class="overline">{{ quote.created | date }}</span>
    </v-list-item-action>
  </v-list-item>
</template>

<script>

export default {
  name: 'Quote',
  props: {
    quote: {
      type: Object
    }
  }
}
</script>
